/**
 * Letter grade (等第) for a score out of `max`.
 *
 * School feedback 2026-09-19: 「作业评分机制不完善:目前只有分数,缺少等第
 * (A、B、C)评分」. Bands follow the ones the score-distribution chart has
 * used since the start (优秀 85–100 / 良好 70–84 / 一般 60–69 / 待改进 <60),
 * expressed as a percentage of the assignment's full mark so a 20-point
 * quiz and a 100-point exam grade the same way. Per-school thresholds can
 * be layered on later without touching call sites.
 */
export type GradeLetter = "A" | "B" | "C" | "D";

export const GRADE_BANDS: { letter: GradeLetter; minPct: number; labelKey: string }[] = [
  { letter: "A", minPct: 85, labelKey: "grade.A" },
  { letter: "B", minPct: 70, labelKey: "grade.B" },
  { letter: "C", minPct: 60, labelKey: "grade.C" },
  { letter: "D", minPct: 0, labelKey: "grade.D" },
];

export function gradeLetter(score: number | null | undefined, max: number): GradeLetter | null {
  if (score == null || !Number.isFinite(score) || !max || max <= 0) return null;
  const pct = (score / max) * 100;
  return GRADE_BANDS.find((b) => pct >= b.minPct)?.letter ?? "D";
}

export const GRADE_STYLES: Record<GradeLetter, string> = {
  A: "bg-emerald-50 text-emerald-700 border-emerald-200",
  B: "bg-sky-50 text-sky-700 border-sky-200",
  C: "bg-amber-50 text-amber-700 border-amber-200",
  D: "bg-rose-50 text-rose-600 border-rose-200",
};
